<template>
    <!--  @71178 - Aba para listar os tipos de agrovisita associados com um assunto de uma agrovisita -->
    <div class="aba-cliente">
        <div class="vertical-flow">
            <div class="columns">
                <!-- PESQUISA E FILTROS -->
                <div class="column" :class="[permissaoVincular ? 'is-6' : 'is-8']">
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-campo-busca-nivel-tecnologico"
                    />
                </div>

                <!-- SITUACAO -->
                <div class="column situacao-select" :class="[permissaoVincular ? 'is-3' : 'is-4']">
                    <vss-select
                        ref="situacaoInput"
                        title="situacao"
                        :options="situacoes"
                        :mlLabels="true"
                        @input="onSituacaoChanged"
                        v-model="situacao"
                        :height="40"
                        :clearable="true"
                    />
                </div>

                <!-- BOTÃO VINCULAR -->
                <div class="column is-3" v-if="permissaoVincular">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalVincularTipo"
                    >
                        {{ $t('vincular-tipo-agrovisita') }}
                    </button>
                </div>
            </div>

            <!-- LISTAGEM -->
            <div class="registry-wrapper">
                <container-loader v-if="isLoading && !$store.getters.isLoading" />
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="asstipoassunto"
                    class="data-table"
                    :mobile-cards="false"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'excluir'">
                            <span v-if="permissao.update && !integracao">
                                <b-button
                                    class="action-button"
                                    :type="props.row['situacao'] == 1 ? 'is-danger' : 'is-success'"
                                    :icon-right="props.row['situacao'] == 1 ? 'delete' : 'check'"
                                    @click="promptChangeSituacao(props.row)"
                                    v-tippy
                                    :title="
                                        $t(props.row['situacao'] == 1 ? 'desativar' : 'reativar')
                                    "
                                />
                            </span>
                        </div>
                        <div v-else-if="f.key == 'situacao'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                v-if="props.row['situacao'] == 1"
                                type="is-success"
                                size="is-medium"
                            >
                                {{ $t('ativo') }}
                            </b-tag>
                            <b-tag
                                class="table-tag table-tag-full-width"
                                v-else
                                type="is-danger"
                                size="is-medium"
                            >
                                {{ $t('inativo') }}</b-tag
                            >
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE ASSOCIACAO -->
            <b-modal :active.sync="showModalAssociacao">
                <div class="bg">
                    <TipoModal
                        :idAssunto="$route.params.id"
                        :permissaoVincular="!integracao"
                        @fecharModal="fecharModal"
                    />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
// SERVICES
import AssTipoVisitaAssuntoVisitaService from '@/services/agro/AssTipoVisitaAssuntoVisitaService';
import TipoModal from '@/components/agro/assunto-agrovisita/modal/AssTipoVisitaAssuntoVisitaModal.vue';

// COMPONENTS
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    components: {
        ContainerLoader,
        TipoModal,
    },
    data() {
        return {
            integracao: this.$store.state.user.tabelasERPWebServer.includes(
                'AGRO_ASSTIPOVISITAASSUNTOVISITA'
            ),
            service: new AssTipoVisitaAssuntoVisitaService(this.$http, this.$router),
            fields: [
                { key: 'codigo', width: 200, sortable: true },
                { key: 'descricao', width: null, sortable: true },
                { key: 'situacao', width: 80, sortable: true, sortFn: null },
                { key: 'excluir', width: 70, sortable: false, sortFn: null },
            ],
            permissao: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            situacao: { id: 2, label: 'todos' },
            situacoes: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'descricao',
            order: 'asc',
            isSaving: false,
            toDelete: null,
            showModalAssociacao: false,
            asstipoassunto: [],

            //permissoes relativas à exibição dos botões
            permissaoVincular: false,

            abrev: this.$route.meta.contexto.slice(0, 3),
            isVenda: this.$route.meta.contexto == 'vendas',
            isAgro: this.$route.meta.contexto == 'agro',
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
            this.permissao = this.hasPermissionAccess(
                'agro',
                'agro-cadastros',
                'agro-assunto-agrovisita'
            );
        } else if (this.isVenda) {
            this.permissao = this.hasPermissionAccess('vendas', 'crm', 'ven-assunto-agrovisita');
        }

        this.permissaoVincular = this.permissao.create && !this.integracao;

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: `${this.abrev}-assunto-agrovisita` },
            });
        } else {
            this.carregarDados();
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        }
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.service
                .findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacao.id,
                    this.$route.params.id,
                    this.abrev,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.asstipoassunto = value;
                    this.isEmpty = this.asstipoassunto.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os usuários!');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    id: m.id,
                    codigo: m.idagro_asstipovisitaassuntovisitaerp,
                    idtipo: m.idtipovisita,
                    idassunto: m.idassuntovisita,
                    descricao: m.tipo.descricao,
                    situacao: m.situacao,
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        onSituacaoChanged(val) {
            this.situacao = val
                ? this.situacoes.filter((v) => v.id == val.id)[0]
                : this.situacoes[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.toDelete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: this.toDelete.descricao.toLocaleUpperCase() }
                );
            this.$root.confirm({
                message: message,
                onConfirm: (_) => this.updateSituacaoRegistro(),
                onCancel: (_) => this.removePrompt(),
            });
        },
        removePrompt() {
            this.toDelete = null;
        },
        updateSituacaoRegistro() {
            let tempAssTipoAssunto = {
                idagro_asstipovisitaassuntovisita: this.toDelete.id,
                situacao: this.toDelete.situacao == 1 ? 0 : 1,
            };

            this.isLoading = true;

            this.service
                .updateSituacao(tempAssTipoAssunto, this.abrev)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess = this.$t(
                                this.toDelete.situacao == 1
                                    ? 'msg-sucesso-ao-reativar-n'
                                    : 'msg-sucesso-ao-desativar-n', 
                                { n: this.toDelete.descricao.toLocaleUpperCase() }
                            );

                        this.$root.showMessage('success', tempSuccess, true, false);

                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure);
                    let msg = this.$t(
                            this.toDelete.situacao == 0
                                ? 'msg-erro-ao-desativar-n'
                                : 'msg-erro-ao-reativar-n', 
                            { n: this.toDelete.descricao.toLocaleUpperCase() }
                        );
                    this.$root.showMessage('error', msg, true, false);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.toDelete = null;
                });
        },
        showModalVincularTipo() {
            this.showModalAssociacao = !this.showModalAssociacao;
        },
        fecharModal() {
            this.showModalAssociacao = false;
            this.carregarDados();
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-cliente {
    height: 100%;

    .situacao-select {
        div {
            height: 40px;
        }
    }

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .search-bar {
            padding-bottom: 0.4rem;
        }

        .situacao-select {
            width: 100%;
            padding-bottom: 0.8rem;
        }

        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
